export default "__VITE_ASSET__iFLPdrAz__";